var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandWhiteBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.575 15.55C11.4417 15.55 11.3127 15.525 11.188 15.475C11.0627 15.425 10.9583 15.3583 10.875 15.275L6.275 10.675C6.09167 10.4917 6 10.2583 6 9.975C6 9.69167 6.09167 9.45833 6.275 9.275C6.45833 9.09167 6.69167 9 6.975 9C7.25833 9 7.49167 9.09167 7.675 9.275L11.575 13.175L15.475 9.275C15.6583 9.09167 15.8917 9 16.175 9C16.4583 9 16.6917 9.09167 16.875 9.275C17.0583 9.45833 17.15 9.69167 17.15 9.975C17.15 10.2583 17.0583 10.4917 16.875 10.675L12.275 15.275C12.175 15.375 12.0667 15.4457 11.95 15.487C11.8333 15.529 11.7083 15.55 11.575 15.55Z",
    fill: "#3B98D1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandWhiteBg);
export default __webpack_public_path__ + "static/media/expand-white-bg.e32fde8e8ad3d0f4bd0a65f6776603d6.svg";
export { ForwardRef as ReactComponent };